"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CenterInput = exports.IconWrapper = exports.InfoText = exports.TitleText = exports.CTAButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("@emcasa/ui-dom/components/Button"));

var _Text = _interopRequireDefault(require("@emcasa/ui-dom/components/Text"));

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var _Input = _interopRequireDefault(require("@emcasa/ui-dom/components/Input"));

var CTAButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "styles__CTAButton",
  componentId: "sc-1jsfyxd-0"
})(["border-color:", ";background-color:", ";color:", ";"], function (_ref) {
  var active = _ref.active,
      selected = _ref.selected,
      disabled = _ref.disabled,
      colors = _ref.theme.colors;
  return (active || selected) && !disabled ? colors.pink : colors.darkSmoke;
}, function (_ref2) {
  var active = _ref2.active,
      disabled = _ref2.disabled,
      colors = _ref2.theme.colors;
  return active && !disabled ? colors.pink : colors.darkSmoke;
}, function (_ref3) {
  var active = _ref3.active,
      disabled = _ref3.disabled,
      colors = _ref3.theme.colors;
  if (disabled || active) return colors.white;else return colors.dark;
});
exports.CTAButton = CTAButton;
var TitleText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "styles__TitleText",
  componentId: "sc-1jsfyxd-1"
})(["font-weight:600;margin:0px 0px 5px 0px;"]);
exports.TitleText = TitleText;
var InfoText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "styles__InfoText",
  componentId: "sc-1jsfyxd-2"
})(["margin:0px;color:#4f4f4f;font-size:16px;"]);
exports.InfoText = InfoText;

var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-1jsfyxd-3"
})(["margin-bottom:", "px;"], (0, _themeGet["default"])('space.4'));

exports.IconWrapper = IconWrapper;
var CenterInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "styles__CenterInput",
  componentId: "sc-1jsfyxd-4"
})(["text-align:center;"]);
exports.CenterInput = CenterInput;